import axios from "axios";
import router from "../router/index";
import store from "../store/index";
import { toCalendar, to404Page } from "./utils";

// 錯誤捕捉
const errorHandle = (status, msg) => {
  switch (status) {
    case 400:
      to404Page();
      break;

    case 401:
      toCalendar();
      break;

    case 403:
      to404Page();
      break;

    case 404:
      to404Page();
      break;

    case 500:
      console.log("500");
      break;

    default:
      to404Page();
      break;
  }
};

// serve 時走 vue.config.js proxy；build / 部署一律用 VUE_APP_BASE_URL（不 proxy）
export const getApiBaseUrl = () => {
  if (process.env.VUE_APP_USE_DEV_PROXY === "true") {
    return "/api/";
  }
  return process.env.VUE_APP_BASE_URL;
};

export const apiBaseUrl = getApiBaseUrl();

// 設定 baseURL
let instance = axios.create({
  baseURL: apiBaseUrl,
});

// request 攔截
instance.interceptors.request.use(
  (config) => {
    const token = process.env.VUE_APP_ENV == "PRO" ? store.state.token : "";
    token && (config.headers.Authorization = `Bearer ${token}`);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response 攔截
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response } = error;

    if (response) {
      errorHandle(response.status, response.data.error);
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);

export default function(method, url, data = null) {
  method = method.toLowerCase();
  if (method == "post") {
    return instance.post(url, data);
  } else if (method == "get") {
    return instance.get(url, { params: data });
  } else if (method == "delete") {
    return instance.delete(url, { params: data });
  } else if (method == "put") {
    return instance.put(url, data);
  } else {
    console.log("未知的 method");
    return false;
  }
}
